'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_SESSION_PROCESS = exports.updateQuickGames = exports.updateBalance = exports.updateRequirePhoneVerification = exports.updatePhoneNumber = exports.updateNetEntSessionId = exports.updateCountryCallingCode = exports.updateEmail = exports.updateAvatarUrl = exports.updateAffiliateClickId = exports.setPlayerDeposited = exports.isSessionUpdated = exports.isSessionActive = exports.hasDeposited = exports.getWaitingRestore = exports.getVip = exports.getValueSegment = exports.getUsername = exports.getUserError = exports.getUserAvatar = exports.getUser = exports.getSessionToken = exports.getSession = exports.getRubies = exports.getQuickGames = exports.getDisplayName = exports.isWithdrawalsDisallowed = exports.isSourceOfWealthDismissable = exports.isSourceOfWealthRequired = exports.isSourceOfFundsRequired = exports.isSourceOfFundsRejected = exports.isSourceOfFundsDismissable = exports.isPhoneVerificationRequired = exports.getPlayerId = exports.getPhoneVerification = exports.getPhoneNumber = exports.getPendingBrainsCents = exports.getPendingBallsCents = exports.getNetEntSessionId = exports.getMoneyBalanceCents = exports.getErrors = exports.getEmail = exports.getCurrency = exports.getCountryCode = exports.getCountryCallingCode = exports.getConsent = exports.getBrainsCents = exports.getBonusBalanceCents = exports.getBetsoftSessionToken = exports.getBtag = exports.getBallsCents = exports.getBalanceCents = exports.getAffiliateId = exports.getAffiliateClickId = exports.dismissErrors = exports.addError = exports.types = exports.session = undefined;

var _templateObject = _taggedTemplateLiteral(['\n          Passing the app state is supported for backwards compatibility reasons\n          and will not work in future. Please update code calling this function\n          to pass only session state.\n          '], ['\n          Passing the app state is supported for backwards compatibility reasons\n          and will not work in future. Please update code calling this function\n          to pass only session state.\n          ']),
    _templateObject2 = _taggedTemplateLiteral(['\n        \'player.requireSourceOfFunds\' boolean flag is deprecated, use\n        \'player.sourceOfFunds.require\' instead.\n        '], ['\n        \'player.requireSourceOfFunds\' boolean flag is deprecated, use\n        \'player.sourceOfFunds.require\' instead.\n        ']),
    _templateObject3 = _taggedTemplateLiteral(['\n        \'player.requireSourceOfWealth\' boolean flag is deprecated, use\n        \'player.sourceOfWealth.require\' instead.\n        '], ['\n        \'player.requireSourceOfWealth\' boolean flag is deprecated, use\n        \'player.sourceOfWealth.require\' instead.\n        ']);

exports.reducer = reducer;
exports.getPersonId = getPersonId;
exports.getSsn = getSsn;

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _md = require('md5');

var _md2 = _interopRequireDefault(_md);

var _commonTags = require('common-tags');

var _uuid = require('uuid');

var _apiClient = require('@rushplay/api-client');

var _websockets = require('@rushplay/websockets');

var websockets = _interopRequireWildcard(_websockets);

var _processes = require('@rushplay/processes');

var processes = _interopRequireWildcard(_processes);

var _reduxEffectsLocalstorage = require('redux-effects-localstorage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /* eslint-disable no-underscore-dangle */


var AUTHORIZATION_TOKEN_KEY_NAME = 'authorizationToken';

var CLEAR_SESSION = 'session/CLEAR_SESSION';
var DISMISS_ERRORS = 'session/DISMISS_ERRORS';
var FETCH_SESSION_PROCESS = 'fetch-session';
var SET_PLAYER_DEPOSITED = 'session/SET_PLAYER_DEPOSITED';
var UPDATE_EMAIL = 'session/UPDATE_EMAIL';
var UPDATE_COUNTRY_CALLING_CODE = 'session/UPDATE_COUNTRY_CALLING_CODE';
var UPDATE_NETENTSESSIONID = 'session/UPDATE_NETENTSESSIONID';
var UPDATE_REQUIRE_PHONE_VERIFICATION = 'session/UPDATE_REQUIRE_PHONE_VERIFICATION';
var UPDATE_PHONE_NUMBER = 'session/UPDATE_PHONE_NUMBER';
var UPDATE_BALANCE = 'session/UPDATE_BALANCE';
var UPDATE_QUICK_GAMES = 'session/UPDATE_QUICK_GAMES';
var UPDATE_AFFILIATE_CLICK_ID = 'session/UPDATE_AFFILIATE_CLICK_ID';
var UPDATE_SESSION = 'session/UPDATE_SESSION';
var WAIT_RESTORE = 'session/WAIT_RESTORE';
var UPDATE_AVATAR_URL = 'session/UPDATE_AVATAR_URL';
var UPDATE_LANGUAGE = 'session/UPDATE_LANGUAGE';

var objectToArray = function objectToArray(obj) {
  return R.unless(R.is(Array), R.of)(obj);
};

var initialState = {
  errors: [],
  player: {},
  quickGames: [],
  token: undefined
};

var unnestSession = function () {
  var warned = false;

  return function unnestSession(state) {
    /* istanbul ignore next: deprecated */
    if (state && state.session) {
      if (process.env.NODE_ENV !== 'production' && !warned) {
        // eslint-disable-next-line no-console
        console.warn('DEPRECATED', (0, _commonTags.oneLine)(_templateObject));
        warned = true;
      }

      return state.session;
    }

    return state;
  };
}();

/**
 * Transform session data into flatter structure by moving data from
 * `player.account` to `player`
 * @private
 * @param {Object} payload Session object
 * @returns {Object} Transformed session object
 */
var unnestPlayerAccount = R.pipe(R.defaultTo({}), R.over(R.lensProp('player'), R.converge(R.merge, [R.defaultTo({}), R.pathOr({}, ['account'])])), R.dissocPath(['player', 'account']));

/**
 * Action creator
 * @param {Object} payload
 * @param {string} payload.token
 */
function storeSession(payload) {
  if (!payload.token) {
    // eslint-disable-next-line no-console
    throw new Error('payload must have token');
  }

  var setTokenAction = (0, _reduxEffectsLocalstorage.setItem)(AUTHORIZATION_TOKEN_KEY_NAME, payload.token, _reduxEffectsLocalstorage.STORAGE_TYPE.session);

  var setLoggedInOnceAction = (0, _reduxEffectsLocalstorage.setItem)('LOGGED_IN_ONCE', true);

  var removeReferralsAction = (0, _reduxEffectsLocalstorage.removeItem)('referrals');

  return [setTokenAction, setLoggedInOnceAction, removeReferralsAction, updateSession(payload)];
}

/**
 * Action creator
 * @param {Object} payload
 */
function updateBalance(payload) {
  return {
    type: UPDATE_BALANCE,
    payload: payload && unnestPlayerAccount(payload)
  };
}

/**
 * Action creator
 * @param {Object} payload
 */
function updateQuickGames(payload) {
  return {
    type: UPDATE_QUICK_GAMES,
    payload: payload
  };
}

/**
 * Action creator
 */
function clearSession() {
  return [{
    type: 'EFFECT_STORAGE',
    payload: {
      type: 'removeItem',
      storageType: _reduxEffectsLocalstorage.STORAGE_TYPE.session,
      key: AUTHORIZATION_TOKEN_KEY_NAME
    }
  }, { type: CLEAR_SESSION }];
}

/**
 * Action creator
 * @param {Object} payload
 */
function updateSession(payload) {
  return {
    type: UPDATE_SESSION,
    payload: payload && unnestPlayerAccount(payload)
  };
}

function updateLanguage(language) {
  return [{
    type: UPDATE_LANGUAGE,
    payload: language
  }, (0, _apiClient.saveLanguagePreference)(language, { version: 1 })];
}

/**
 * Action creator
 * @param {boolean} payload
 */
function waitRestoreSession(payload) {
  return {
    type: WAIT_RESTORE,
    payload: payload
  };
}

/**
 * Action creator
 * @param {string} type - action type
 * @param {Object} payload
 */
function addError(type, payload) {
  return {
    type: type,
    error: true,
    payload: payload
  };
}

/**
 * Action creator
 * @param {string|string[]} payload - UUID or array of UUIDs
 */
function dismissErrors(payload) {
  return {
    type: DISMISS_ERRORS,
    payload: payload
  };
}

/**
 * Action creator
 * @param {string} affiliateId
 * @param {number} depositAmount
 * @param {string} userId
 */

//meta is needed for GA_EVENT definitions
function setPlayerDeposited(affiliateId, depositAmount, userId) {
  return {
    type: SET_PLAYER_DEPOSITED,
    meta: {
      affiliateId: affiliateId,
      depositAmount: depositAmount,
      userId: userId
    }
  };
}

/**
 * Action creator.
 * @param {boolean} payload
 */
function updateCountryCallingCode(payload) {
  return {
    type: UPDATE_COUNTRY_CALLING_CODE,
    payload: payload
  };
}

/**
 * Action creator.
 * @param {string} payload
 */
function updateNetEntSessionId(payload) {
  return {
    type: UPDATE_NETENTSESSIONID,
    payload: payload
  };
}

/**
 * Action creator.
 * @param {boolean} payload
 */
function updateRequirePhoneVerification(payload) {
  return {
    type: UPDATE_REQUIRE_PHONE_VERIFICATION,
    payload: payload
  };
}

/**
 * Action creator.
 * @param {boolean} payload
 */
function updatePhoneNumber(payload) {
  return {
    type: UPDATE_PHONE_NUMBER,
    payload: payload
  };
}

/**
 * Action creator
 * @param {string} email
 */

function updateEmail(payload) {
  return {
    type: UPDATE_EMAIL,
    payload: payload
  };
}

function updateAvatarUrl(url) {
  return {
    type: UPDATE_AVATAR_URL,
    payload: url
  };
}

/**
 * Action creator
 * @param {string} token
 */

//TODO: https://github.com/RushPlay/session/issues/17
function refreshSession(token) {
  return [processes.start(FETCH_SESSION_PROCESS), (0, _apiClient.fetchSession)({
    token: token,
    success: function success(response) {
      return [updateSession(response.value), processes.stop(FETCH_SESSION_PROCESS)];
    },
    failure: function failure(response) {
      return [addError(UPDATE_SESSION, response.value), updateNetEntSessionId(), processes.stop(FETCH_SESSION_PROCESS)];
    },
    version: 1
  })];
}

function updateAffiliateClickId(clickId) {
  return {
    type: UPDATE_AFFILIATE_CLICK_ID,
    payload: clickId
  };
}

/**
 * Reducer
 */
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  var payload = action.payload;

  if (action.error) {
    var assocUuid = function assocUuid(item) {
      return R.assoc('uuid', (0, _uuid.v4)(), item);
    };

    var error = R.objOf('payload', action.payload);

    return R.over(R.lensProp('errors'), R.append(assocUuid(error)), state);
  }

  switch (action.type) {
    case UPDATE_SESSION:
      {
        return payload ? R.merge(state, payload) : R.merge(state, { token: '' });
      }

    case UPDATE_LANGUAGE:
      {
        return R.assocPath(['player', 'language'], action.payload, state);
      }

    case websockets.SESSION_EXPIRED:
    case CLEAR_SESSION:
      return R.merge(initialState, { token: '' });

    case SET_PLAYER_DEPOSITED:
      return R.assocPath(['player', 'deposited'], true, state);

    case UPDATE_COUNTRY_CALLING_CODE:
      return R.assocPath(['player', 'address', 'countryCallingCode'], payload, state);

    case websockets.BALANCE_CHANGED:
    case UPDATE_BALANCE:
      {

        if (R.gte(R.path(['player', 'lastFetched'], state), payload.timestamp)) {
          return state;
        }

        var nextPlayerState = R.pickBy(R.complement(R.isNil), {
          currency: payload.currency,
          rubies: payload.rubies,
          bonusBalanceCents: payload.bonusBalanceCents,
          moneyBalanceCents: payload.moneyBalanceCents,
          ballsCents: payload.ballsCents,
          ballsPendingCents: payload.ballsPendingCents,
          brainsCents: payload.brainsCents,
          brainsPendingCents: payload.brainsPendingCents,
          lastFetched: payload.timestamp
        });

        return R.over(R.lensProp('player'), function (playerState) {
          return R.mergeDeepRight(playerState, nextPlayerState);
        }, state);
      }

    case UPDATE_NETENTSESSIONID:
      return R.assocPath(['player', 'netEntSessionId'], payload, state);

    case UPDATE_REQUIRE_PHONE_VERIFICATION:
      return R.assocPath(['player', 'requiresPhoneValidation'], payload, state);

    case UPDATE_PHONE_NUMBER:
      return R.assocPath(['player', 'address', 'mobile'], payload, state);

    case UPDATE_EMAIL:
      return R.assocPath(['player', 'email'], payload, state);

    case UPDATE_AVATAR_URL:
      return R.assocPath(['player', 'avatarImageUrl'], payload, state);

    case UPDATE_QUICK_GAMES:
      return R.assoc('quickGames', payload, state);

    case WAIT_RESTORE:
      return R.assoc('waitingRestore', payload, state);

    case DISMISS_ERRORS:
      {
        var errorUuids = objectToArray(payload);

        var isErrorInPayload = function isErrorInPayload(error) {
          return R.contains(R.prop('uuid', error), errorUuids);
        };

        return R.over(R.lensProp('errors'), R.reject(isErrorInPayload), state);
      }

    case UPDATE_AFFILIATE_CLICK_ID:
      {
        return R.unless(R.pipe(getAffiliateClickId, Boolean), R.assocPath(['player', 'affiliateClickId'], action.payload))(state);
      }

    default:
      return state;
  }
}

/**
 * @param {Object} state
 * @returns {boolean}
 */
function isSessionUpdated(state) {
  return typeof R.path(['token'], unnestSession(state)) === 'string';
}

/**
 * @param {Object} state
 * @returns {string}
 */
function getSessionToken(state) {
  return R.path(['token'], unnestSession(state));
}

/**
 * @param {Object} state
 * @returns {boolean}
 */
function isSessionActive(state) {
  return Boolean(R.path(['token'], unnestSession(state)));
}

/**
 * @param {Object} state
 * @returns {array}
 */
function getQuickGames(state) {
  return R.path(['quickGames'], unnestSession(state));
}

/**
 * @param {Object} state
 * @returns {Object}
 */
function getSession(state) {
  return unnestSession(state);
}

/**
 * @param {Object} state
 * @returns {number}
 */
function getRubies(state) {
  return R.path(['player', 'rubies'], unnestSession(state));
}

/**
 * @param {Object} state
 * @returns {number}
 */
function getMoneyBalanceCents(state) {
  return R.path(['player', 'moneyBalanceCents'], unnestSession(state));
}

/**
 * @param {Object} state
 * @returns {number}
 */
function getBonusBalanceCents(state) {
  return R.path(['player', 'bonusBalanceCents'], unnestSession(state));
}

/**
 * @param {Object} state
 * @returns {number}
 */
function getBalanceCents(state) {
  return getBonusBalanceCents(state) + getMoneyBalanceCents(state);
}

/**
 * @param {Object} state
 * @returns {number}
 */
function getBrainsCents(state) {
  return R.path(['player', 'brainsCents'], unnestSession(state));
}

/**
 * @param {Object} state
 * @returns {number}
 */
function getBallsCents(state) {
  return R.path(['player', 'ballsCents'], unnestSession(state));
}

/**
 * @param {Object} state
 * @returns {boolean}
 */
function hasDeposited(state) {
  return R.path(['player', 'deposited'], unnestSession(state));
}

/**
 * @param {Object} state
 * @returns {string}
 */
function getUserAvatar(state) {
  return R.path(['player', 'avatarImageUrl'], unnestSession(state));
}

/**
 * @param {Object} state
 * @returns {string}
 */
function getUsername(state) {
  return R.path(['player', 'username'], unnestSession(state));
}

/**
 * @param {Object} state
 * @returns {string}
 */
function getDisplayName(state) {
  return R.path(['player', 'displayName'], unnestSession(state));
}

/**
 * @param {Object} state
 * @returns {Object}
 */
function getUser(state) {
  return R.path(['player'], unnestSession(state));
}

/**
 * @param {Object} state
 * @returns {string}
 */
function getEmail(state) {
  return R.path(['player', 'email'], unnestSession(state));
}

/**
 * @param {Object} state
 * @returns {boolean}
 */
function getVip(state) {
  return R.path(['player', 'vip'], unnestSession(state));
}

/**
 * @param {Object} state
 * @returns {string}
 */
function getCountryCode(state) {
  return R.path(['player', 'countryCode'], unnestSession(state));
}

/**
 * @param {Object} state
 * @returns {string}
 */
function getCurrency(state) {
  return R.path(['player', 'currency'], unnestSession(state));
}

/**
 * @param {Object} state
 * @returns {string}
 */
function getNetEntSessionId(state) {
  return R.path(['player', 'netEntSessionId'], unnestSession(state));
}

/**
 * @param {Object} state
 * @returns {string}
 */
function getBetsoftSessionToken(state) {
  return R.path(['player', 'betsoftSessionToken'], unnestSession(state));
}

/**
 * @param {Object} state
 * @returns {Object}
 */
function getUserError(state) {
  return R.path(['player', 'error'], unnestSession(state));
}

/**
 * @param {Object} state
 * @returns {number}
 */
function getPendingBallsCents(state) {
  return R.path(['player', 'ballsPendingCents'], unnestSession(state));
}

/**
 * @param {Object} state
 * @returns {number}
 */
function getPendingBrainsCents(state) {
  return R.path(['player', 'brainsPendingCents'], unnestSession(state));
}

/**
 * @param {Object} state
 * @returns {boolean}
 */
function getWaitingRestore(state) {
  return R.path(['waitingRestore'], unnestSession(state));
}

/**
 * @param {Object} state
 * @returns {boolean}
 */
function isWithdrawalsDisallowed(state) {
  return R.pathOr(false, ['player', 'withdrawalsDisallowed'], unnestSession(state));
}

/**
 * @param {Object} state
 * @returns {?string}
 */
function getAffiliateId(state) {
  return R.path(['player', 'affiliateId'], unnestSession(state));
}

/**
 * @param {Object} state
 * @returns {?string}
 */
function getAffiliateTag(state) {
  return R.path(['player', 'affiliateTag'], unnestSession(state));
}

/**
 * @param {Object} state
 * @returns {?string}
 */
function getBtag(state) {
  var affiliateId = getAffiliateId(state);
  var affiliateTag = getAffiliateTag(state);

  if (!affiliateId || !affiliateTag) {
    return null;
  }

  return affiliateId + '_' + affiliateTag;
}

/**
 * @param {Object} state
 * @returns {Object[]}
 */
function getErrors(state) {
  return R.path(['errors'], unnestSession(state));
}

/**
 * @param {Object} state
 * @returns {boolean}
 */
function isPhoneVerificationRequired(state) {
  return R.equals(R.path(['player', 'requiresPhoneValidation'], unnestSession(state)), 'restricted');
}

/**
 * @param {Object} state
 * @returns {string}
 */
function getPhoneVerification(state) {
  return R.path(['player', 'requiresPhoneValidation'], unnestSession(state));
}

/**
 * @param {Object} state
 * @returns {string}
 */
function getPersonId(state) {
  return R.pathOr('', ['player', 'personId'], unnestSession(state));
}

/**
 * @param {Object} state
 * @returns {string}
 */
function getSsn(state) {
  return R.slice(2, Infinity, getPersonId(state));
}

/**
 * Get player’s consent to Terms and Conditions.
 * @param {Object} state
 * @returns {boolean} `true` if player accepted TaC, `false` otherwise.
 */
function getConsent(state) {
  return R.path(['player', 'tcAccepted'], unnestSession(state));
}

/**
 * Get player’s status of Source of Funds
 * @param {Object} state
 * @returns {boolean} `true` if player is required to submit SoF, `false` otherwise.
 */
function isSourceOfFundsRequired(state) {
  var boolean = R.path(['player', 'requireSourceOfFunds'], unnestSession(state));
  /* istanbul ignore next: deprecated */
  if (process.env.NODE_ENV !== 'production') {
    if (typeof boolean !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn('DEPRECATED', (0, _commonTags.oneLine)(_templateObject2));
    }
  }
  var object = R.path(['player', 'sourceOfFunds', 'require'], unnestSession(state));
  return R.defaultTo(boolean, object);
}

/**
 * Get players status of Source of Funds dismissable
 * @param {Object} state
 * @returns {boolean} `true` if player can dismiss the SoF for now
 */
function isSourceOfFundsDismissable(state) {
  return R.path(['player', 'sourceOfFunds', 'dismissable'], unnestSession(state));
}

/**
 * Get players status of Source of Funds rejected
 * @param {Object} state
 * @returns {boolean} `true` if player's SoF was rejected
 */
function isSourceOfFundsRejected(state) {
  return R.path(['player', 'sourceOfFunds', 'rejected'], unnestSession(state));
}

/**
 * Get player’s status of Source of Wealth
 * @param {Object} state
 * @returns {boolean} `true` if player is required to submit SoW, `false` otherwise.
 */
function isSourceOfWealthRequired(state) {
  var boolean = R.path(['player', 'requireSourceOfWealth'], unnestSession(state));
  /* istanbul ignore next: deprecated */
  if (process.env.NODE_ENV !== 'production') {
    if (typeof boolean !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn('DEPRECATED', (0, _commonTags.oneLine)(_templateObject3));
    }
  }
  var object = R.path(['player', 'sourceOfWealth', 'require'], unnestSession(state));
  return R.defaultTo(boolean, object);
}

/**
 * Get players status of Source of Wealth dismissable
 * @param {Object} state
 * @returns {boolean} `true` if player can dismiss the SoW for now
 */
function isSourceOfWealthDismissable(state) {
  return R.path(['player', 'sourceOfWealth', 'dismissable'], unnestSession(state));
}

/**
 * @param {Object} state
 * @returns {string}
 */
function getPhoneNumber(state) {
  return R.path(['player', 'address', 'mobile'], unnestSession(state));
}

/**
 * @param {Object} state
 * @returns {string}
 */
function getCountryCallingCode(state) {
  return R.path(['player', 'address', 'countryCallingCode'], unnestSession(state));
}

/**
 * @param {Object} state
 * @returns {string}
 */
function getAffiliateClickId(state) {
  return R.pathOr('', ['player', 'affiliateClickId'], state);
}

/**
 * @param {Object} state
 * @returns {?string}
 */
function getPlayerId(state) {
  var username = getUsername(state);
  return typeof username === 'string' ? (0, _md2.default)(username) : null;
}

/**
 * @param {Object} state
 * @returns {?string}
 */
function getValueSegment(state) {
  return R.path(['player', 'segments', 'valueSegment'], unnestSession(state));
}

var session = exports.session = {
  clear: clearSession,
  refresh: refreshSession,
  store: storeSession,
  update: updateSession,
  updateLanguage: updateLanguage,
  waitRestore: waitRestoreSession
};

var types = exports.types = {
  LOGOUT: CLEAR_SESSION,
  DISMISS_ERRORS: DISMISS_ERRORS,
  SET_PLAYER_DEPOSITED: SET_PLAYER_DEPOSITED,
  UPDATE_AVATAR_URL: UPDATE_AVATAR_URL,
  UPDATE_EMAIL: UPDATE_EMAIL,
  UPDATE_COUNTRY_CALLING_CODE: UPDATE_COUNTRY_CALLING_CODE,
  UPDATE_NETENTSESSIONID: UPDATE_NETENTSESSIONID,
  UPDATE_REQUIRE_PHONE_VERIFICATION: UPDATE_REQUIRE_PHONE_VERIFICATION,
  UPDATE_PHONE_NUMBER: UPDATE_PHONE_NUMBER,
  UPDATE_BALANCE: UPDATE_BALANCE,
  UPDATE_QUICK_GAMES: UPDATE_QUICK_GAMES,
  UPDATE_SESSION: UPDATE_SESSION,
  WAIT_RESTORE: WAIT_RESTORE
};

exports.addError = addError;
exports.dismissErrors = dismissErrors;
exports.getAffiliateClickId = getAffiliateClickId;
exports.getAffiliateId = getAffiliateId;
exports.getBalanceCents = getBalanceCents;
exports.getBallsCents = getBallsCents;
exports.getBtag = getBtag;
exports.getBetsoftSessionToken = getBetsoftSessionToken;
exports.getBonusBalanceCents = getBonusBalanceCents;
exports.getBrainsCents = getBrainsCents;
exports.getConsent = getConsent;
exports.getCountryCallingCode = getCountryCallingCode;
exports.getCountryCode = getCountryCode;
exports.getCurrency = getCurrency;
exports.getEmail = getEmail;
exports.getErrors = getErrors;
exports.getMoneyBalanceCents = getMoneyBalanceCents;
exports.getNetEntSessionId = getNetEntSessionId;
exports.getPendingBallsCents = getPendingBallsCents;
exports.getPendingBrainsCents = getPendingBrainsCents;
exports.getPhoneNumber = getPhoneNumber;
exports.getPhoneVerification = getPhoneVerification;
exports.getPlayerId = getPlayerId;
exports.isPhoneVerificationRequired = isPhoneVerificationRequired;
exports.isSourceOfFundsDismissable = isSourceOfFundsDismissable;
exports.isSourceOfFundsRejected = isSourceOfFundsRejected;
exports.isSourceOfFundsRequired = isSourceOfFundsRequired;
exports.isSourceOfWealthRequired = isSourceOfWealthRequired;
exports.isSourceOfWealthDismissable = isSourceOfWealthDismissable;
exports.isWithdrawalsDisallowed = isWithdrawalsDisallowed;
exports.getDisplayName = getDisplayName;
exports.getQuickGames = getQuickGames;
exports.getRubies = getRubies;
exports.getSession = getSession;
exports.getSessionToken = getSessionToken;
exports.getUser = getUser;
exports.getUserAvatar = getUserAvatar;
exports.getUserError = getUserError;
exports.getUsername = getUsername;
exports.getValueSegment = getValueSegment;
exports.getVip = getVip;
exports.getWaitingRestore = getWaitingRestore;
exports.hasDeposited = hasDeposited;
exports.isSessionActive = isSessionActive;
exports.isSessionUpdated = isSessionUpdated;
exports.setPlayerDeposited = setPlayerDeposited;
exports.updateAffiliateClickId = updateAffiliateClickId;
exports.updateAvatarUrl = updateAvatarUrl;
exports.updateEmail = updateEmail;
exports.updateCountryCallingCode = updateCountryCallingCode;
exports.updateNetEntSessionId = updateNetEntSessionId;
exports.updatePhoneNumber = updatePhoneNumber;
exports.updateRequirePhoneVerification = updateRequirePhoneVerification;
exports.updateBalance = updateBalance;
exports.updateQuickGames = updateQuickGames;
exports.FETCH_SESSION_PROCESS = FETCH_SESSION_PROCESS;
/* eslint-enable no-underscore-dangle */